import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import ProgressBar from '@components/@core/ProgressBar';

const NewHireOrientations = ({ employees }) => {
    const navigate = useNavigate();
    const users = useSelector((state) => state.app.users);
    const reports = useSelector((state) => state.manage.managerDashboard);
    const { certifications_assigned, certifications_completed, new_hires } = reports.new_hire;

    return (
        <div className="card mb-3 custom-width">
            <p className="dsl-b22 bold">New Hire Orientations</p>
            <div className="d-flex">
                <div className="newhire-card me-3">
                    <p className="dsl-m12 text-400 mb-0">New Hires</p>
                    <p className="dsl-m12 text-400 mb-2">this month</p>
                    <p className="dsl-b16 text-400 mb-0">{new_hires}</p>
                </div>
                <div className="newhire-card me-3">
                    <p className="dsl-m12 text-400 mb-0">Certifications</p>
                    <p className="dsl-m12 text-400 mb-2">Assigned</p>
                    <p className="dsl-b16 text-400 mb-0">{certifications_assigned}</p>
                </div>
                <div className="newhire-card">
                    <p className="dsl-m12 text-400 mb-0">Certifications</p>
                    <p className="dsl-m12 text-400 mb-2">Completed</p>
                    <p className="dsl-b16 text-400 mb-0">{certifications_completed}</p>
                </div>
            </div>
            <p className="dsl-b18 bold mt-4">New Hires</p>
            <div className="px-0 px-md-3">
                <div className="d-flex pb-3 border-bottom">
                    <span className="dsl-m12 text-400 d-flex-4">Employee</span>
                    <span className="dsl-m12 text-400 d-flex-1">Active</span>
                    <span className="dsl-m12 text-400 d-flex-3">Completed</span>
                </div>
                {employees?.length > 0 ? (
                    employees?.map((item, index) => {
                        const user = find(propEq('id', item.id), users);
                        const fullName = item.profile.first_name + ' ' + item.profile.last_name;
                        if (index < 3) {
                            return (
                                <div className="d-flex align-items-center mt-3" key={`nh${index}`}>
                                    <div className="d-flex d-flex-4 align-items-center">
                                        <Avatar name={fullName} url={user?.avatar || item.profile.avatar} />
                                        <span className="dsl-b16 ms-3">{fullName}</span>
                                    </div>
                                    <div className="d-flex-1">
                                        <span className="dsl-b16 text-400">{item?.active || 'No'}</span>
                                    </div>
                                    <div className="d-flex-3">
                                        <ProgressBar value={item?.completed_percent || 0} />
                                    </div>
                                </div>
                            );
                        }
                    })
                ) : (
                    <p className="dsl-m12 text-center mt-3">No new hires</p>
                )}
            </div>
            <div className="justify-end mt-3">
                <Button className="text-400 me-2" type="low" name="ADD EMPLOYEE" onClick={() => navigate('/hcm/record-add-employee')} />
                <Button className="text-400" type="medium" name="NEW HIRE REPORT" onClick={() => navigate('/hcm/report-new-hire-orientation')} />
            </div>
        </div>
    );
};

export default memo(NewHireOrientations);
